import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { orgService } from "@/services/orgService";

export function useOrg() {
  return useQuery({ queryKey: ["org"], queryFn: orgService.get });
}

function useInvalidatingMutation(fn, options) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: fn,
    ...options,
    onSuccess: (...args) => {
      qc.invalidateQueries({ queryKey: ["org"] });
      options.onSuccess?.(...args);
    },
  });
}

export function useCreateOrg(options = {}) { return useInvalidatingMutation(orgService.create, options); }
export function useUpdateOrg(options = {}) { return useInvalidatingMutation(orgService.update, options); }
export function useInviteMember(options = {}) { return useInvalidatingMutation(orgService.invite, options); }
export function useJoinOrg(options = {}) { return useInvalidatingMutation(orgService.join, options); }
export function useCancelInvite(options = {}) { return useInvalidatingMutation(orgService.cancelInvite, options); }
export function useRemoveMember(options = {}) { return useInvalidatingMutation(orgService.removeMember, options); }
export function useSetMemberRole(options = {}) { return useInvalidatingMutation(orgService.setMemberRole, options); }
